import { FC, ReactNode } from 'react';

import { Button, Tooltip } from '@purpur/library';
import { IconInfo } from '@purpur/library/icon/info';

import { withA11yVisuallyHidden } from '@telialt/common-a11y/src/withA11yVisuallyHidden';
import { useTranslations } from '@telialt/common-cms/src/useTranslations';

import { LineData } from './model';
import { OfferPriceLine, StyledOfferLineWithTooltip } from './ProductOfferPrices.styles';

const AccessibleOfferPriceLine = withA11yVisuallyHidden(OfferPriceLine);

type Props = {
    children: ReactNode;
    line: LineData;
    accessible: string;
    dataTest?: string;
};

export const OfferLine: FC<Props> = ({ children, line, accessible, dataTest }) => {
    const { t } = useTranslations();

    return (
        <StyledOfferLineWithTooltip data-test={dataTest}>
            <AccessibleOfferPriceLine accessible={accessible}>{children}</AccessibleOfferPriceLine>

            {line.showTooltip && (
                <Tooltip
                    triggerElement={
                        <Button iconOnly={true} size="md" aria-label={t['common.tooltip.aria_label']} variant="text">
                            <IconInfo size="xs" />
                        </Button>
                    }
                >
                    {t['eshop.product_page.product_offer_prices.offer_tooltip']}
                </Tooltip>
            )}
        </StyledOfferLineWithTooltip>
    );
};
